import ValidationTab from '@/components/validation/ValidationTab'
import ValidationHistory from '@/components/validation/ValidationHistory'
import Configs from '@/components/configs/Configs'
import Events from '@/components/events/EventsList'
import Login from '@/components/auth/Login'

export default [
  { path: '/', name: 'ValidationTab', component: ValidationTab },
  { path: '/validations', name: 'ValidationHistory', component: ValidationHistory },
  { path: '/config', name: 'Configs', component: Configs },
  { path: '/events', name: 'Events', component: Events },
  { path: '/login', name: 'Login', component: Login }
]



// WEBPACK FOOTER //
// ./src/router/index.js